import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import SEO from '../../components/SEO';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import EventCard from './components/EventCard';
import EventCalendar from './components/EventCalendar';
import PromotionBanner from './components/PromotionBanner';
import EventFilters from './components/EventFilters';
import { generatePageSEO } from '../../utils/seoData';

const EventsAndPromotions = () => {
  const [activeTab, setActiveTab] = useState('events');
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const seoData = generatePageSEO('events');
  const [filters, setFilters] = useState({});
  const [viewMode, setViewMode] = useState('grid'); // grid, list, calendar

  // Mock events data
  const mockEvents = [
    {
      id: 1,
      title: "Encontro de Carros",
      description: `Evento de carros 1 vez no mês, sempre na segunda quinta-feira.\nExposição e encontro de apaixonados por carros.\nEntrada gratuita.`,
      date: "2025-02-13",
      startTime: "19:00",
      endTime: "22:00",
      location: "Área externa",
      organizer: "Estação Marina da Rocha",
      price: 0,
      type: "evento",
      category: "entretenimento",
      image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800&h=600&fit=crop",
      tags: ["Carros", "Encontro", "Mensal"],
      featured: true,
      registrationOpen: true
    },
    {
      id: 2,
      title: "Karaokê da Sexta",
      description: `Karaokê toda sexta-feira.\nMúsica, diversão e ambiente descontraído para todos.`,
      date: "2025-02-14",
      startTime: "19:30",
      endTime: "22:30",
      location: "Praça de Alimentação",
      organizer: "Estação Marina da Rocha",
      price: 0,
      type: "evento",
      category: "entretenimento",
      image: "https://images.unsplash.com/photo-1515169067865-5387ec356754?w=800&h=600&fit=crop",
      tags: ["Karaokê", "Sexta", "Semanal"],
      featured: true,
      registrationOpen: true
    },
    {
      id: 3,
      title: "Noite da Pizza",
      description: `Pizza toda sexta à noite.\nSeleções especiais e clima perfeito para a família.`,
      date: "2025-02-14",
      startTime: "20:00",
      endTime: "23:00",
      location: "Área gastronômica",
      organizer: "Estação Marina da Rocha",
      price: 0,
      type: "evento",
      category: "alimentacao",
      image: "https://images.unsplash.com/photo-1548365328-8b7a2d2d96f1?w=800&h=600&fit=crop",
      tags: ["Pizza", "Sexta", "Gastronomia"],
      featured: false,
      registrationOpen: true
    }
  ];

  // Mock promotions data
  const mockPromotions = [
    {
      id: 1,
      title: "Mega Promoção de Verão",
      description: `Descontos imperdíveis em toda a coleção de verão!\nRoupas, acessórios e calçados com até 70% de desconto.\nPromoção válida apenas neste final de semana.`,
      bannerImage: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200&h=600&fit=crop",
      discountType: "percentage",
      discountValue: 70,
      storeName: "Fashion Store",
      category: "moda",
      startDate: "2025-01-10",
      endDate: "2025-01-15",
      code: "VERAO70",
      minPurchase: 100,
      featured: true,
      terms: `Promoção válida de 10/01 a 15/01/2025.\nNão cumulativa com outras promoções.\nCompra mínima de R$ 100,00.`
    },
    {
      id: 2,
      title: "Happy Hour Gastronômico",
      description: `Pratos especiais com preços promocionais das 17h às 19h.\nCardápio executivo com entrada, prato principal e sobremesa.\nAmbiente aconchegante com música ao vivo.`,
      bannerImage: "https://images.pexels.com/photos/1267320/pexels-photo-1267320.jpeg?w=1200&h=600&fit=crop",
      discountType: "percentage",
      discountValue: 30,
      storeName: "Sabor & Arte Restaurante",
      category: "alimentacao",
      startDate: "2025-01-08",
      endDate: "2025-01-31",
      code: null,
      minPurchase: null,
      featured: false,
      terms: `Válido de segunda a sexta, das 17h às 19h.\nNão válido em feriados.\nSujeito à disponibilidade.`
    },
    {
      id: 3,
      title: "Compre 1 Leve 2 em Cosméticos",
      description: `Oferta especial em produtos de beleza selecionados.\nMarcas nacionais e importadas participando da promoção.\nRenove seu kit de beleza com economia garantida.`,
      bannerImage: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1200&h=600&fit=crop",
      discountType: "bogo",
      discountValue: "Compre 1 Leve 2",
      storeName: "Beleza & Charme",
      category: "moda",
      startDate: "2025-01-12",
      endDate: "2025-01-20",
      code: "BELEZA2X1",
      minPurchase: 50,
      featured: true,
      terms: `Válido para produtos selecionados.\nO produto de menor valor sai grátis.\nCompra mínima de R$ 50,00.`
    },
    {
      id: 4,
      title: "Desconto Especial em Eletrônicos",
      description: `Smartphones, tablets e acessórios com descontos especiais.\nMarcas renomadas com garantia estendida.\nParcelamento em até 12x sem juros.`,
      bannerImage: "https://images.unsplash.com/photo-1468495244123-6c6c332eeece?w=1200&h=600&fit=crop",
      discountType: "fixed",
      discountValue: 200,
      storeName: "TechHub Marina",
      category: "tecnologia",
      startDate: "2025-01-05",
      endDate: "2025-01-25",
      code: "TECH200",
      minPurchase: 500,
      featured: false,
      terms: `Desconto de R$ 200 em compras acima de R$ 500.\nParcelamento sujeito à aprovação de crédito.\nEstoque limitado.`
    }
  ];

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleClearFilters = () => {
    setFilters({});
  };


  const handlePromotionClaim = (promotion) => {
    console.log('Promotion claimed:', promotion);
    alert(`Promoção "${promotion?.title}" resgatada com sucesso!`);
  };

  const handleShare = (item) => {
    if (navigator.share) {
      navigator.share({
        title: item?.title,
        text: item?.description,
        url: window.location?.href
      });
    } else {
      // Fallback for browsers that don't support Web Share API
      navigator.clipboard?.writeText(window.location?.href);
      alert('Link copiado para a área de transferência!');
    }
  };

  const filteredEvents = mockEvents?.filter(event => {
    if (filters?.search && !event?.title?.toLowerCase()?.includes(filters?.search?.toLowerCase())) {
      return false;
    }
    if (filters?.type && event?.type !== filters?.type) {
      return false;
    }
    if (filters?.category && event?.category !== filters?.category) {
      return false;
    }
    if (filters?.availableOnly && !event?.registrationOpen) {
      return false;
    }
    if (filters?.freeOnly && event?.price > 0) {
      return false;
    }
    if (filters?.featuredOnly && !event?.featured) {
      return false;
    }
    return true;
  });

  const eventStats = {
    total: mockEvents?.length,
    thisWeek: mockEvents?.filter(event => {
      const eventDate = new Date(event.date);
      const now = new Date();
      const weekFromNow = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
      return eventDate >= now && eventDate <= weekFromNow;
    })?.length
  };

  return (
    <div className="min-h-screen bg-background">
      <SEO {...seoData} />
      <Header />
      <main className="pt-16">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-primary via-primary/90 to-accent py-16 px-4">
          <div className="max-w-7xl mx-auto text-center">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
              <Icon name="Calendar" size={16} className="text-white" />
              <span className="text-white text-sm font-medium">
                Eventos & Promoções
              </span>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6">
              Descubra Experiências
              <br />
              <span className="text-accent">Únicas e Ofertas</span> Especiais
            </h1>
            
            <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">
              Participe de workshops, eventos comunitários e aproveite promoções exclusivas 
              das lojas do Estação Marina da Rocha
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
              <Button
                variant="secondary"
                size="lg"
                onClick={() => setActiveTab('events')}
                className="w-full sm:w-auto"
              >
                <Icon name="Calendar" size={20} className="mr-2" />
                Ver Eventos
              </Button>
              <Button
                variant="outline"
                size="lg"
                onClick={() => setActiveTab('promotions')}
                className="w-full sm:w-auto bg-white/10 border-white/30 text-white hover:bg-white/20"
              >
                <Icon name="Tag" size={20} className="mr-2" />
                Ver Promoções
              </Button>
            </div>
          </div>
        </section>

        {/* Navigation Tabs */}
        <section className="bg-background border-b border-border sticky top-16 z-40">
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex items-center justify-between py-4">
              <nav className="flex space-x-1">
                <button
                  onClick={() => setActiveTab('events')}
                  className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    activeTab === 'events' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground hover:bg-muted'
                  }`}
                >
                  <Icon name="Calendar" size={16} />
                  <span>Eventos</span>
                  <span className="bg-accent text-accent-foreground text-xs px-2 py-0.5 rounded-full">
                    {filteredEvents?.length}
                  </span>
                </button>
                
                <button
                  onClick={() => setActiveTab('promotions')}
                  className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    activeTab === 'promotions' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground hover:bg-muted'
                  }`}
                >
                  <Icon name="Tag" size={16} />
                  <span>Promoções</span>
                  <span className="bg-accent text-accent-foreground text-xs px-2 py-0.5 rounded-full">
                    {mockPromotions?.length}
                  </span>
                </button>
              </nav>

              {activeTab === 'events' && (
                <div className="flex items-center space-x-2">
                  <Button
                    variant={viewMode === 'grid' ? 'default' : 'ghost'}
                    size="sm"
                    onClick={() => setViewMode('grid')}
                  >
                    <Icon name="Grid3X3" size={16} />
                  </Button>
                  <Button
                    variant={viewMode === 'list' ? 'default' : 'ghost'}
                    size="sm"
                    onClick={() => setViewMode('list')}
                  >
                    <Icon name="List" size={16} />
                  </Button>
                  <Button
                    variant={viewMode === 'calendar' ? 'default' : 'ghost'}
                    size="sm"
                    onClick={() => setViewMode('calendar')}
                  >
                    <Icon name="Calendar" size={16} />
                  </Button>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-8 px-4">
          <div className="max-w-7xl mx-auto">
            {activeTab === 'events' ? (
              <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                {/* Filters Sidebar */}
                <div className="lg:col-span-1">
                  <EventFilters
                    filters={filters}
                    onFilterChange={handleFilterChange}
                    onClearFilters={handleClearFilters}
                    eventStats={eventStats}
                  />
                </div>

                {/* Events Content */}
                <div className="lg:col-span-3">
                  {viewMode === 'calendar' ? (
                    <EventCalendar
                      events={filteredEvents}
                      selectedDate={selectedDate}
                      onDateSelect={setSelectedDate}
                      currentMonth={currentMonth}
                      onMonthChange={setCurrentMonth}
                    />
                  ) : (
                    <>
                      <div className="flex items-center justify-between mb-6">
                        <h2 className="text-2xl font-heading font-semibold text-foreground">
                          {filteredEvents?.length} Evento{filteredEvents?.length !== 1 ? 's' : ''} Encontrado{filteredEvents?.length !== 1 ? 's' : ''}
                        </h2>
                      </div>

                      <div className={`${
                        viewMode === 'grid' ?'grid grid-cols-1 md:grid-cols-2 gap-6' :'space-y-6'
                      }`}>
                        {filteredEvents?.map((event) => (
                          <EventCard
                            key={event?.id}
                            event={event}
                            onShare={handleShare}
                          />
                        ))}
                      </div>

                      {filteredEvents?.length === 0 && (
                        <div className="text-center py-12">
                          <Icon name="Calendar" size={48} className="text-muted-foreground mx-auto mb-4" />
                          <h3 className="text-lg font-medium text-foreground mb-2">
                            Nenhum evento encontrado
                          </h3>
                          <p className="text-muted-foreground mb-4">
                            Tente ajustar os filtros para encontrar eventos que interessam você.
                          </p>
                          <Button variant="outline" onClick={handleClearFilters}>
                            Limpar Filtros
                          </Button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            ) : (
              /* Promotions Content */
              (<div>
                <div className="flex items-center justify-between mb-8">
                  <h2 className="text-2xl font-heading font-semibold text-foreground">
                    Promoções Ativas
                  </h2>
                  <div className="text-sm text-muted-foreground">
                    {mockPromotions?.length} promoção{mockPromotions?.length !== 1 ? 'ões' : ''} disponível{mockPromotions?.length !== 1 ? 'eis' : ''}
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  {mockPromotions?.map((promotion) => (
                    <PromotionBanner
                      key={promotion?.id}
                      promotion={promotion}
                      onClaim={handlePromotionClaim}
                      onShare={handleShare}
                    />
                  ))}
                </div>
              </div>)
            )}
          </div>
        </section>

        {/* CTA Section */}
        <section className="bg-muted py-16 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-heading font-bold text-foreground mb-4">
              Não Perca Nenhuma Novidade
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              Cadastre-se para receber notificações sobre novos eventos e promoções exclusivas
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Seu melhor email"
                className="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              />
              <Button size="lg" className="w-full sm:w-auto">
                Cadastrar
              </Button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default EventsAndPromotions;